var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Collapse", {
    staticClass:
      "green-operation__assessment green-operation__waste-and-recycling",
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _c(
              "HKLLeftRight",
              [
                _c("span", { staticClass: "font-bold" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "tenancy.greenOperation.assessments.wasteAndRecycling.title"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                !_vm.isEdit && _vm.canViewPoint
                  ? _c("HKLInputPoints", {
                      attrs: { isEdit: false },
                      model: {
                        value: _vm.points,
                        callback: function ($$v) {
                          _vm.points = $$v
                        },
                        expression: "points",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              [
                _c(
                  "HKLLeftRight",
                  { staticClass: "green-operation__assessment-title" },
                  [
                    _c("span", { staticClass: "font-bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "tenancy.greenOperation.assessments.wasteAndRecycling.foodWasteCollectionCollaboration"
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "green-operation__assessment-form row" },
                  [
                    _vm.isTenant
                      ? [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.foodWasteCollectionCollaborationHint) +
                              "\n        "
                          ),
                        ]
                      : _vm._l(
                          _vm.optionMap.foodWasteCollectionCollaboration,
                          function (option, index) {
                            return _c(
                              "HKLRadioButton",
                              {
                                key: index,
                                staticClass: "small-4",
                                attrs: {
                                  disabled: !_vm.isEdit,
                                  value: option.value,
                                },
                                model: {
                                  value:
                                    _vm.foodWasteCollectionCollaboration.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.foodWasteCollectionCollaboration,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "foodWasteCollectionCollaboration.value",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(option.label) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        ),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "HKLLeftRight",
                  { staticClass: "green-operation__assessment-title" },
                  [
                    _c("span", { staticClass: "font-bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "tenancy.greenOperation.assessments.wasteAndRecycling.dedicatedRecyclingFacilitiesIncluded"
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.canViewPoint
                      ? _c("HKLInputPoints", {
                          attrs: { isEdit: _vm.isEdit },
                          model: {
                            value:
                              _vm.dedicatedRecyclingFacilitiesIncluded.point,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dedicatedRecyclingFacilitiesIncluded,
                                "point",
                                $$v
                              )
                            },
                            expression:
                              "dedicatedRecyclingFacilitiesIncluded.point",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "green-operation__assessment-form row" },
                  [
                    _vm.isTenant
                      ? [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.dedicatedRecyclingFacilitiesIncludedHint
                              ) +
                              "\n        "
                          ),
                        ]
                      : _vm._l(
                          _vm.optionMap.dedicatedRecyclingFacilitiesIncluded,
                          function (option, index) {
                            return _c(
                              "HKLCheckbox",
                              {
                                key: index,
                                staticClass: "small-4",
                                attrs: { disabled: !_vm.isEdit },
                                model: {
                                  value:
                                    _vm.dedicatedRecyclingFacilitiesIncluded
                                      .value[option.key],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dedicatedRecyclingFacilitiesIncluded
                                        .value,
                                      option.key,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "dedicatedRecyclingFacilitiesIncluded.value[option.key]",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(option.label) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        ),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.tableAttrs.dataSource.length > 0
              ? _c("HKLTable", _vm._b({}, "HKLTable", _vm.tableAttrs, false))
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }